import { ADVERTISING_ENTITIES } from 'src/utils/entityDefinitions/entities/advertisingEntities';
import { ATLAS_ENTITIES } from 'src/utils/entityDefinitions/entities/atlasEntities';
import { BEACON_ENTITIES } from 'src/utils/entityDefinitions/entities/beaconEntities';
import { OMNI_ENTITIES } from 'src/utils/entityDefinitions/entities/omniEntities';

export { ADVERTISING_ENTITIES, ATLAS_ENTITIES, BEACON_ENTITIES, OMNI_ENTITIES };
